// Types
import { RootState } from 'types/RootState.types';

export const getFormSelector = (state: RootState) => state.form;
export const getFormGuestFormSelector = (state: RootState) => state.form?.guestForm;
export const getSavedCardFormSubmitFailedSelector =
    (state: RootState) => (state.form?.savedCardDetailsForm?.submitFailed ||
        state.form?.billingDetailsForm?.submitFailed) || false;
export const getPromoCodeEntrySelector = (state:RootState) => state.form?.promoCodeForm?.values || null;
export const getFormValuesSelector = (
  state: RootState,
  formId: string,
) => state.form?.[formId]?.values;
export const getFormSubmitFailedSelector = (
  state: RootState,
  formId: string,
) => state.form?.[formId]?.submitFailed ?? false;
export const getFormSyncErrorsSelector = (
  state: RootState,
  formId: string,
) => state.form?.[formId]?.syncErrors;
export const getFormAnyTouchedSelector = (
  state: RootState,
  formId: string,
) => state.form?.[formId]?.anyTouched ?? false;
